const ipAddress = process.env.REACT_APP_BACKEND_IPADDRESS;

export function GetApiWithoutToken(endPoint) {
  return fetch(`${ipAddress}/${endPoint}`, {
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      "Cache-Control": "no-store",
      "X-Content-Type-Options": "nosniff",
      "Strict-Transport-Security": "max-age=31536000; includeSubDomains",
      "Access-Control-Allow-Origin": ipAddress,
      "Referrer-Policy": "no-referrer",
    },
  })
    .then((response) =>
      response.json().then((json) => ({ ...json, status: response.status })),
    )
    .catch((error) => {
      return error;
    });
}

export function PostApiWithoutToken(endPoint, body) {
  return fetch(`${ipAddress}/${endPoint}`, {
    method: "POST",
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      "Cache-Control": "no-store",
      "X-Content-Type-Options": "nosniff",
      "Strict-Transport-Security": "max-age=31536000; includeSubDomains",
      "Access-Control-Allow-Origin": ipAddress,
      "Referrer-Policy": "no-referrer",
    },
    body: body,
  })
    .then((response) =>
      response.json().then((json) => ({ ...json, status: response.status })),
    )
    .catch((error) => {
      return error;
    });
}

export function UpdateApiWithoutToken(endPoint, body) {
  return fetch(`${ipAddress}/${endPoint}`, {
    method: "PUT",
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      "Cache-Control": "no-store",
      "X-Content-Type-Options": "nosniff",
      "Strict-Transport-Security": "max-age=31536000; includeSubDomains",
      "Access-Control-Allow-Origin": ipAddress,
      "Referrer-Policy": "no-referrer",
    },
    body: body,
  })
    .then((response) =>
      response.json().then((json) => ({ ...json, status: response.status })),
    )
    .catch((error) => {
      return error;
    });
}

export function GetApi(endPoint, token) {
  return fetch(`${ipAddress}/${endPoint}`, {
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: `Bearer ${token}`,
      "Cache-Control": "no-store",
      "X-Content-Type-Options": "nosniff",
      "Strict-Transport-Security": "max-age=31536000; includeSubDomains",
      "Access-Control-Allow-Origin": ipAddress,
      "Referrer-Policy": "no-referrer",
    },
  })
    .then((response) =>
      response.json().then((json) => ({ ...json, status: response.status })),
    )
    .catch((error) => {
      return error;
    });
}

export function PostApi(endPoint, token, body) {
  return fetch(`${ipAddress}/${endPoint}`, {
    method: "POST",
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: `Bearer ${token}`,
      "Cache-Control": "no-store",
      "X-Content-Type-Options": "nosniff",
      "Strict-Transport-Security": "max-age=31536000; includeSubDomains",
      "Access-Control-Allow-Origin": ipAddress,
      "Referrer-Policy": "no-referrer",
    },
    body: body,
  })
    .then((response) =>
      response.json().then((json) => ({ ...json, status: response.status })),
    )
    .catch((error) => {
      return error;
    });
}

export function UpdateApi(endPoint, token, body) {
  return fetch(`${ipAddress}/${endPoint}`, {
    method: "PUT",
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: `Bearer ${token}`,
      "Cache-Control": "no-store",
      "X-Content-Type-Options": "nosniff",
      "Strict-Transport-Security": "max-age=31536000; includeSubDomains",
      "Access-Control-Allow-Origin": ipAddress,
      "Referrer-Policy": "no-referrer",
    },
    body: body,
  })
    .then((response) =>
      response.json().then((json) => ({ ...json, status: response.status })),
    )
    .catch((error) => {
      return error;
    });
}
export function PatchApi(endPoint, token, body) {
  return fetch(`${ipAddress}/${endPoint}`, {
    method: "PATCH",
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: `Bearer ${token}`,
      "Cache-Control": "no-store",
      "X-Content-Type-Options": "nosniff",
      "Strict-Transport-Security": "max-age=31536000; includeSubDomains",
      "Access-Control-Allow-Origin": ipAddress,
      "Referrer-Policy": "no-referrer",
    },
    body: body,
  })
    .then((response) =>
      response.json().then((json) => ({ ...json, status: response.status })),
    )
    .catch((error) => {
      return error;
    });
}

export function DeleteApi(endPoint, token) {
  return fetch(`${ipAddress}/${endPoint}`, {
    method: "DELETE",
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: `Bearer ${token}`,
      "Cache-Control": "no-store",
      "X-Content-Type-Options": "nosniff",
      "Strict-Transport-Security": "max-age=31536000; includeSubDomains",
      "Access-Control-Allow-Origin": ipAddress,
      "Referrer-Policy": "no-referrer",
    },
  })
    .then((response) =>
      response.json().then((json) => ({ ...json, status: response.status })),
    )
    .catch((error) => {
      return error;
    });
}

export function FormDataPostApi(endPoint, token, formData) {
  return fetch(`${ipAddress}/${endPoint}`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: formData,
  })
    .then((response) =>
      response.json().then((json) => ({ ...json, status: response.status })),
    )
    .catch((error) => {
      return error;
    });
}

export const DownloadFiles = async (endPoint, token) => {
  const response = await fetch(`${ipAddress}/${endPoint}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return response;
};
